// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Option-module__font-s-10___sALUT {
  font-size: 10px !important;
}

.Option-module__font-s-12___rMw12 {
  font-size: 12px !important;
}

.Option-module__font-s-13___lkAgd {
  font-size: 13px !important;
}

.Option-module__font-s-14___UUmBf {
  font-size: 14px !important;
}

.Option-module__font-s-15___o3UCO {
  font-size: 15px !important;
}

.Option-module__font-s-16___nHK0g {
  font-size: 16px !important;
}

.Option-module__font-s-18___PSePB {
  font-size: 18px !important;
}

.Option-module__font-s-20___XIt0Q {
  font-size: 20px !important;
}

.Option-module__font-s-22____9c9M {
  font-size: 22px !important;
}

.Option-module__font-s-28___UpZZF {
  font-size: 28px !important;
}

.Option-module__font-w-400___Nwpe6 {
  font-weight: 400 !important;
}

.Option-module__font-w-500___gLHwJ {
  font-weight: 500 !important;
}

.Option-module__font-w-600___GfsV_ {
  font-weight: 600 !important;
}

.Option-module__font-w-700___hFMSy {
  font-weight: 700 !important;
}

.Option-module__p-5___lw9GC {
  padding: 5px !important;
}

.Option-module__p-12___Or_hR {
  padding: 12px !important;
}

.Option-module__p-16___ooA9x {
  padding: 16px !important;
}

.Option-module__p-30___DldKK {
  padding: 30px !important;
}

.Option-module__p-b-0___f1vYl {
  padding-bottom: 0 !important;
}

.Option-module__p-b-5___PdQ7y {
  padding-bottom: 5px !important;
}

.Option-module__p-b-10___VFKTi {
  padding-bottom: 10px !important;
}

.Option-module__p-b-12___hKj0T {
  padding-bottom: 12px !important;
}

.Option-module__p-b-16___k75UD {
  padding-bottom: 16px !important;
}

.Option-module__p-b-18___zw8a9 {
  padding-bottom: 18px !important;
}

.Option-module__p-b-20___aWCql {
  padding-bottom: 20px !important;
}

.Option-module__p-b-25___cRhPQ {
  padding-bottom: 25px !important;
}

.Option-module__p-b-30___YdmM2 {
  padding-bottom: 30px !important;
}

.Option-module__p-b-50___GMncM {
  padding-bottom: 50px !important;
}

.Option-module__p-t-0___MXEAP {
  padding-top: 0 !important;
}

.Option-module__p-t-12___HNDg4 {
  padding-top: 12px !important;
}

.Option-module__p-t-16___VQ9Zl {
  padding-top: 16px !important;
}

.Option-module__p-t-18___gGgo4 {
  padding-top: 18px !important;
}

.Option-module__p-t-20___pg6r8 {
  padding-top: 20px !important;
}

.Option-module__p-t-30___Grh7B {
  padding-top: 30px !important;
}

.Option-module__p-t-40___Oez0i {
  padding-top: 40px !important;
}

.Option-module__p-t-50___IV1ld {
  padding-top: 50px !important;
}

.Option-module__p-l-20___RL1n7 {
  padding-left: 20px !important;
}

.Option-module__p-l-30___w3FMn {
  padding-left: 30px !important;
}

.Option-module__p-l-40___EaGQy {
  padding-left: 40px !important;
}

.Option-module__p-r-16___H19M6 {
  padding-right: 16px !important;
}

.Option-module__p-r-20___uxrNI {
  padding-right: 20px !important;
}

.Option-module__p-r-30___KEF_O {
  padding-right: 30px !important;
}

.Option-module__p-r-50___Ewxh_ {
  padding-right: 50px !important;
}

.Option-module__p-r-60___MPDII {
  padding-right: 60px !important;
}

.Option-module__m-b-1___Tx65y {
  margin-bottom: 1px !important;
}

.Option-module__m-b-2___gvApC {
  margin-bottom: 2px !important;
}

.Option-module__m-b-6___vGA7P {
  margin-bottom: 6px !important;
}

.Option-module__m-b-8___yizls {
  margin-bottom: 8px !important;
}

.Option-module__m-b-10___kOhuz {
  margin-bottom: 10px !important;
}

.Option-module__m-b-14___V8jUd {
  margin-bottom: 14px !important;
}

.Option-module__m-b-16___KjTEm {
  margin-bottom: 16px !important;
}

.Option-module__m-b-20___ey9RS {
  margin-bottom: 20px !important;
}

.Option-module__m-b-22___yr_Kp {
  margin-bottom: 22px !important;
}

.Option-module__m-b-24___Ncjbn {
  margin-bottom: 24px !important;
}

.Option-module__m-b-30___Fotts {
  margin-bottom: 30px !important;
}

.Option-module__m-b-32___px7qW {
  margin-bottom: 32px !important;
}

.Option-module__m-b-40___zfE8B {
  margin-bottom: 40px !important;
}

.Option-module__m-t-2___RziBs {
  margin-top: 2px !important;
}

.Option-module__m-t-3___BIH1T {
  margin-top: 3px !important;
}

.Option-module__m-t-4___wWrd2 {
  margin-top: 4px !important;
}

.Option-module__m-t-5___qaBFQ {
  margin-top: 5px !important;
}

.Option-module__m-t-8___Pn_LO {
  margin-top: 8px !important;
}

.Option-module__m-t-10___cM0pR {
  margin-top: 10px !important;
}

.Option-module__m-t-15___WcPai {
  margin-top: 15px !important;
}

.Option-module__m-t-16___er5Ql {
  margin-top: 16px !important;
}

.Option-module__m-t-20___oQ8BJ {
  margin-top: 20px !important;
}

.Option-module__m-t-22___Mmqxs {
  margin-top: 22px !important;
}

.Option-module__m-t-30___lnzLQ {
  margin-top: 30px !important;
}

.Option-module__m-t-32___OGu3q {
  margin-top: 32px !important;
}

.Option-module__m-l-auto___BP7MI {
  margin-left: auto !important;
}

.Option-module__m-l-4___ooQt1 {
  margin-left: 4px !important;
}

.Option-module__m-l-5___Ojnh1 {
  margin-left: 5px !important;
}

.Option-module__m-l-6___IX7Yk {
  margin-left: 6px !important;
}

.Option-module__m-l-8___N5r1O {
  margin-left: 8px !important;
}

.Option-module__m-l-10___Qz5Is {
  margin-left: 10px !important;
}

.Option-module__m-l-16___xzyIH {
  margin-left: 16px !important;
}

.Option-module__m-l-20___z8Z7V {
  margin-left: 20px !important;
}

.Option-module__m-l-24___ojWjF {
  margin-left: 24px !important;
}

.Option-module__m-l-30___B_t24 {
  margin-left: 30px !important;
}

.Option-module__m-l-35___tv0kw {
  margin-left: 35px !important;
}

.Option-module__m-l-40___GoYxS {
  margin-left: 40px !important;
}

.Option-module__m-r-8___U4VTJ {
  margin-right: 8px !important;
}

.Option-module__m-r-10___mEkTg {
  margin-right: 10px !important;
}

.Option-module__m-r-16___wXzao {
  margin-right: 16px !important;
}

.Option-module__m-r-20___Qy8dN {
  margin-right: 20px !important;
}

.Option-module__m-r-24___UND3y {
  margin-right: 24px !important;
}

.Option-module__m-r-30___M3pyu {
  margin-right: 30px !important;
}

.Option-module__m-r-40___p4j_0 {
  margin-right: 40px !important;
}

.Option-module__border-r-3___Pdnzb {
  border-radius: 3px !important;
}

.Option-module__border-r-4___UVTgn {
  border-radius: 4px !important;
}

.Option-module__border-r-6___hMifH {
  border-radius: 6px !important;
}

.Option-module__border-r-10___FWB2r {
  border-radius: 10px !important;
}

.Option-module__border-r-12___z3imd {
  border-radius: 12px !important;
}

.Option-module__border-r-16___SutNc {
  border-radius: 16px !important;
}

.Option-module__border-r-50___g0rdC {
  border-radius: 50% !important;
}

.Option-module__primary-border___A3bwa {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__primary-border-b___vOUGd {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__primary-border-t___OAhJm {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__primary-border-l___bqSFG {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__primary-border-r___V0iXa {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Option-module__secondary-border___FE2k0 {
  border: 1px solid #637768;
}

.Option-module__secondary-border-b___OcCy2 {
  border-bottom: 1px solid #637768;
}

.Option-module__secondary-border-t___QpRga {
  border-top: 1px solid #637768;
}

.Option-module__secondary-border-l___t5uOU {
  border-left: 1px solid #637768;
}

.Option-module__secondary-border-r___M6iLq {
  border-right: 1px solid #637768;
}

.Option-module__gap-0___DWdnb {
  gap: 0 !important;
}

.Option-module__gap-2___DXQv2 {
  gap: 2px !important;
}

.Option-module__gap-4___JcCP9 {
  gap: 4px !important;
}

.Option-module__gap-5___Vpuba {
  gap: 5px !important;
}

.Option-module__gap-6___p9xoN {
  gap: 6px !important;
}

.Option-module__gap-8___Otfio {
  gap: 8px !important;
}

.Option-module__gap-10___mx9Pl {
  gap: 10px !important;
}

.Option-module__gap-12___ujdor {
  gap: 12px !important;
}

.Option-module__gap-14___JBynf {
  gap: 14px !important;
}

.Option-module__gap-16___cahzW {
  gap: 16px !important;
}

.Option-module__gap-18___RaBEW {
  gap: 18px !important;
}

.Option-module__gap-20___uNtrM {
  gap: 20px !important;
}

.Option-module__gap-24____rBuL {
  gap: 24px !important;
}

.Option-module__gap-26___ICvZD {
  gap: 26px !important;
}

.Option-module__gap-30___W1dRd {
  gap: 30px !important;
}

.Option-module__gap-32___GQ90_ {
  gap: 32px !important;
}

.Option-module__gap-40___iPmGK {
  gap: 40px !important;
}

.Option-module__gap-50___jdJ_x {
  gap: 50px !important;
}

.Option-module__flex-1___ohawC {
  flex: 1;
}

.Option-module__flex-none___wF3AP {
  flex: none !important;
}

.Option-module__flex-column___k_PFW {
  display: flex;
  flex-direction: column !important;
}

.Option-module__flex-row___sprwy {
  display: flex;
  flex-direction: row !important;
}

.Option-module__vertically-centered___cwprs {
  display: flex;
  align-items: center !important;
}

.Option-module__horizontally-centered___hN1UR {
  display: flex;
  justify-content: center !important;
}

.Option-module__horizontally-end___Z_QA9 {
  display: flex;
  justify-content: end !important;
}

.Option-module__vertically-start___qQcsd {
  display: flex;
  align-items: start !important;
}

.Option-module__space-between___Eh3uG {
  display: flex;
  justify-content: space-between !important;
}

.Option-module__flex-wrap___yyDMB {
  flex-wrap: wrap !important;
}

.Option-module__height-100____OJXr {
  height: 100%;
}

.Option-module__width-50___Ag9eY {
  width: 50% !important;
}

.Option-module__width-100___tnE9X {
  width: 100%;
}

.Option-module__cursor-pointer___c4c6d {
  cursor: pointer;
}

.Option-module__cursor-not-allowed___m8ZTI {
  cursor: not-allowed !important;
}

.Option-module__absolute-centered___N6b63 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Option-module__absolute___q1pRl {
  position: absolute;
}

.Option-module__relative___i2s0g {
  position: relative;
}

.Option-module__fixed___JbpER {
  position: fixed;
}

.Option-module__visible___tF_JW {
  opacity: 1;
}

.Option-module__invisible___PeVYP {
  opacity: 0;
}

.Option-module__col-90___gBBn7 {
  width: 90% !important;
}

.Option-module__col-auto___F1fLR {
  width: auto !important;
}

.Option-module__medical-tabs___v1OV_ {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Option-module__medical-table-new___TpwMt {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Option-module__medical-table-new___TpwMt:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Option-module__medical-table-new___TpwMt::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Option-module__medical-table-new___TpwMt::-webkit-scrollbar-track {
  display: none;
}
.Option-module__medical-table-new___TpwMt.Option-module__no-pagination___eh76j {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Option-module__medical-table-new___TpwMt.Option-module__no-pagination___eh76j:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Option-module__medical-table-new___TpwMt.Option-module__no-pagination___eh76j::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Option-module__medical-table-new___TpwMt.Option-module__no-pagination___eh76j::-webkit-scrollbar-track {
  display: none;
}

.Option-module__medical-table-empty___znNn6 {
  padding: 14px 40px !important;
}

.Option-module__icon-btn___l7VIQ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Option-module__search-icon___mt4E9 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Option-module__disable-select___XLoVc {
  user-select: none;
}

.Option-module__break-word___H0akO {
  word-break: break-word;
}

.Option-module__popup-clear-btn___ETskr {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Option-module__scroll-m-b-20___ntOyz {
  scroll-margin-bottom: 20px;
}

.Option-module__option___R6amF {
  color: #375844;
  box-sizing: border-box;
  word-break: break-all;
  cursor: pointer;
  padding: 10px;
  height: 40px;
  gap: 6px;
}
.Option-module__option___R6amF:not(:last-child) {
  margin-bottom: 7px;
}
.Option-module__option___R6amF:hover, .Option-module__option___R6amF.Option-module__selected___q86SK {
  background-color: #ece7e7;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/FormSelect/Option/Option.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,QAAA;AA8pBF;AA5pBE;EACE,kBAAA;AA8pBJ;AA3pBE;EAEE,yBAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.option {\n  color: get-color(greenNew, dark);\n  box-sizing: border-box;\n  word-break: break-all;\n  cursor: pointer;\n  padding: 10px;\n  height: 40px;\n  gap: 6px;\n\n  &:not(:last-child) {\n    margin-bottom: 7px;\n  }\n\n  &:hover,\n  &.selected {\n    background-color: get-color(grayNew, medium);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Option-module__font-s-10___sALUT`,
	"fontS12": `Option-module__font-s-12___rMw12`,
	"fontS13": `Option-module__font-s-13___lkAgd`,
	"fontS14": `Option-module__font-s-14___UUmBf`,
	"fontS15": `Option-module__font-s-15___o3UCO`,
	"fontS16": `Option-module__font-s-16___nHK0g`,
	"fontS18": `Option-module__font-s-18___PSePB`,
	"fontS20": `Option-module__font-s-20___XIt0Q`,
	"fontS22": `Option-module__font-s-22____9c9M`,
	"fontS28": `Option-module__font-s-28___UpZZF`,
	"fontW400": `Option-module__font-w-400___Nwpe6`,
	"fontW500": `Option-module__font-w-500___gLHwJ`,
	"fontW600": `Option-module__font-w-600___GfsV_`,
	"fontW700": `Option-module__font-w-700___hFMSy`,
	"p5": `Option-module__p-5___lw9GC`,
	"p12": `Option-module__p-12___Or_hR`,
	"p16": `Option-module__p-16___ooA9x`,
	"p30": `Option-module__p-30___DldKK`,
	"pB0": `Option-module__p-b-0___f1vYl`,
	"pB5": `Option-module__p-b-5___PdQ7y`,
	"pB10": `Option-module__p-b-10___VFKTi`,
	"pB12": `Option-module__p-b-12___hKj0T`,
	"pB16": `Option-module__p-b-16___k75UD`,
	"pB18": `Option-module__p-b-18___zw8a9`,
	"pB20": `Option-module__p-b-20___aWCql`,
	"pB25": `Option-module__p-b-25___cRhPQ`,
	"pB30": `Option-module__p-b-30___YdmM2`,
	"pB50": `Option-module__p-b-50___GMncM`,
	"pT0": `Option-module__p-t-0___MXEAP`,
	"pT12": `Option-module__p-t-12___HNDg4`,
	"pT16": `Option-module__p-t-16___VQ9Zl`,
	"pT18": `Option-module__p-t-18___gGgo4`,
	"pT20": `Option-module__p-t-20___pg6r8`,
	"pT30": `Option-module__p-t-30___Grh7B`,
	"pT40": `Option-module__p-t-40___Oez0i`,
	"pT50": `Option-module__p-t-50___IV1ld`,
	"pL20": `Option-module__p-l-20___RL1n7`,
	"pL30": `Option-module__p-l-30___w3FMn`,
	"pL40": `Option-module__p-l-40___EaGQy`,
	"pR16": `Option-module__p-r-16___H19M6`,
	"pR20": `Option-module__p-r-20___uxrNI`,
	"pR30": `Option-module__p-r-30___KEF_O`,
	"pR50": `Option-module__p-r-50___Ewxh_`,
	"pR60": `Option-module__p-r-60___MPDII`,
	"mB1": `Option-module__m-b-1___Tx65y`,
	"mB2": `Option-module__m-b-2___gvApC`,
	"mB6": `Option-module__m-b-6___vGA7P`,
	"mB8": `Option-module__m-b-8___yizls`,
	"mB10": `Option-module__m-b-10___kOhuz`,
	"mB14": `Option-module__m-b-14___V8jUd`,
	"mB16": `Option-module__m-b-16___KjTEm`,
	"mB20": `Option-module__m-b-20___ey9RS`,
	"mB22": `Option-module__m-b-22___yr_Kp`,
	"mB24": `Option-module__m-b-24___Ncjbn`,
	"mB30": `Option-module__m-b-30___Fotts`,
	"mB32": `Option-module__m-b-32___px7qW`,
	"mB40": `Option-module__m-b-40___zfE8B`,
	"mT2": `Option-module__m-t-2___RziBs`,
	"mT3": `Option-module__m-t-3___BIH1T`,
	"mT4": `Option-module__m-t-4___wWrd2`,
	"mT5": `Option-module__m-t-5___qaBFQ`,
	"mT8": `Option-module__m-t-8___Pn_LO`,
	"mT10": `Option-module__m-t-10___cM0pR`,
	"mT15": `Option-module__m-t-15___WcPai`,
	"mT16": `Option-module__m-t-16___er5Ql`,
	"mT20": `Option-module__m-t-20___oQ8BJ`,
	"mT22": `Option-module__m-t-22___Mmqxs`,
	"mT30": `Option-module__m-t-30___lnzLQ`,
	"mT32": `Option-module__m-t-32___OGu3q`,
	"mLAuto": `Option-module__m-l-auto___BP7MI`,
	"mL4": `Option-module__m-l-4___ooQt1`,
	"mL5": `Option-module__m-l-5___Ojnh1`,
	"mL6": `Option-module__m-l-6___IX7Yk`,
	"mL8": `Option-module__m-l-8___N5r1O`,
	"mL10": `Option-module__m-l-10___Qz5Is`,
	"mL16": `Option-module__m-l-16___xzyIH`,
	"mL20": `Option-module__m-l-20___z8Z7V`,
	"mL24": `Option-module__m-l-24___ojWjF`,
	"mL30": `Option-module__m-l-30___B_t24`,
	"mL35": `Option-module__m-l-35___tv0kw`,
	"mL40": `Option-module__m-l-40___GoYxS`,
	"mR8": `Option-module__m-r-8___U4VTJ`,
	"mR10": `Option-module__m-r-10___mEkTg`,
	"mR16": `Option-module__m-r-16___wXzao`,
	"mR20": `Option-module__m-r-20___Qy8dN`,
	"mR24": `Option-module__m-r-24___UND3y`,
	"mR30": `Option-module__m-r-30___M3pyu`,
	"mR40": `Option-module__m-r-40___p4j_0`,
	"borderR3": `Option-module__border-r-3___Pdnzb`,
	"borderR4": `Option-module__border-r-4___UVTgn`,
	"borderR6": `Option-module__border-r-6___hMifH`,
	"borderR10": `Option-module__border-r-10___FWB2r`,
	"borderR12": `Option-module__border-r-12___z3imd`,
	"borderR16": `Option-module__border-r-16___SutNc`,
	"borderR50": `Option-module__border-r-50___g0rdC`,
	"primaryBorder": `Option-module__primary-border___A3bwa`,
	"primaryBorderB": `Option-module__primary-border-b___vOUGd`,
	"primaryBorderT": `Option-module__primary-border-t___OAhJm`,
	"primaryBorderL": `Option-module__primary-border-l___bqSFG`,
	"primaryBorderR": `Option-module__primary-border-r___V0iXa`,
	"secondaryBorder": `Option-module__secondary-border___FE2k0`,
	"secondaryBorderB": `Option-module__secondary-border-b___OcCy2`,
	"secondaryBorderT": `Option-module__secondary-border-t___QpRga`,
	"secondaryBorderL": `Option-module__secondary-border-l___t5uOU`,
	"secondaryBorderR": `Option-module__secondary-border-r___M6iLq`,
	"gap0": `Option-module__gap-0___DWdnb`,
	"gap2": `Option-module__gap-2___DXQv2`,
	"gap4": `Option-module__gap-4___JcCP9`,
	"gap5": `Option-module__gap-5___Vpuba`,
	"gap6": `Option-module__gap-6___p9xoN`,
	"gap8": `Option-module__gap-8___Otfio`,
	"gap10": `Option-module__gap-10___mx9Pl`,
	"gap12": `Option-module__gap-12___ujdor`,
	"gap14": `Option-module__gap-14___JBynf`,
	"gap16": `Option-module__gap-16___cahzW`,
	"gap18": `Option-module__gap-18___RaBEW`,
	"gap20": `Option-module__gap-20___uNtrM`,
	"gap24": `Option-module__gap-24____rBuL`,
	"gap26": `Option-module__gap-26___ICvZD`,
	"gap30": `Option-module__gap-30___W1dRd`,
	"gap32": `Option-module__gap-32___GQ90_`,
	"gap40": `Option-module__gap-40___iPmGK`,
	"gap50": `Option-module__gap-50___jdJ_x`,
	"flex1": `Option-module__flex-1___ohawC`,
	"flexNone": `Option-module__flex-none___wF3AP`,
	"flexColumn": `Option-module__flex-column___k_PFW`,
	"flexRow": `Option-module__flex-row___sprwy`,
	"verticallyCentered": `Option-module__vertically-centered___cwprs`,
	"horizontallyCentered": `Option-module__horizontally-centered___hN1UR`,
	"horizontallyEnd": `Option-module__horizontally-end___Z_QA9`,
	"verticallyStart": `Option-module__vertically-start___qQcsd`,
	"spaceBetween": `Option-module__space-between___Eh3uG`,
	"flexWrap": `Option-module__flex-wrap___yyDMB`,
	"height100": `Option-module__height-100____OJXr`,
	"width50": `Option-module__width-50___Ag9eY`,
	"width100": `Option-module__width-100___tnE9X`,
	"cursorPointer": `Option-module__cursor-pointer___c4c6d`,
	"cursorNotAllowed": `Option-module__cursor-not-allowed___m8ZTI`,
	"absoluteCentered": `Option-module__absolute-centered___N6b63`,
	"absolute": `Option-module__absolute___q1pRl`,
	"relative": `Option-module__relative___i2s0g`,
	"fixed": `Option-module__fixed___JbpER`,
	"visible": `Option-module__visible___tF_JW`,
	"invisible": `Option-module__invisible___PeVYP`,
	"col90": `Option-module__col-90___gBBn7`,
	"colAuto": `Option-module__col-auto___F1fLR`,
	"medicalTabs": `Option-module__medical-tabs___v1OV_`,
	"medicalTableNew": `Option-module__medical-table-new___TpwMt`,
	"noPagination": `Option-module__no-pagination___eh76j`,
	"medicalTableEmpty": `Option-module__medical-table-empty___znNn6`,
	"iconBtn": `Option-module__icon-btn___l7VIQ`,
	"searchIcon": `Option-module__search-icon___mt4E9`,
	"disableSelect": `Option-module__disable-select___XLoVc`,
	"breakWord": `Option-module__break-word___H0akO`,
	"popupClearBtn": `Option-module__popup-clear-btn___ETskr`,
	"scrollMB20": `Option-module__scroll-m-b-20___ntOyz`,
	"option": `Option-module__option___R6amF`,
	"selected": `Option-module__selected___q86SK`
};
module.exports = ___CSS_LOADER_EXPORT___;
